export default __webpack_public_path__ + "e6fff2085ef71a06e0f32f028fdea917.png";